// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mcp-admin-merchant-details-section__header[data-v-6aa1777e] div.v-application--wrap{margin-top:0;min-height:auto}", ""]);
// Exports
module.exports = exports;
